import { render } from "./HowItWorks.vue?vue&type=template&id=14e4bb88&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=14e4bb88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e4bb88"]])

export default __exports__